import { useEffect } from 'react'

// HACER SCROLL HACIA ARRIBA
const ScrollToTop = (location: string) => {
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}, [location])
}

export { ScrollToTop }
